<script setup lang="ts">
import { ref } from 'vue';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import axios from 'axios';

import { useViewStore } from '@/stores/viewStore'
import { useUserStore } from '@/stores/userStore';

import { useI18n } from 'vue-i18n';

const viewStore = useViewStore();
const userStore = useUserStore();


const email = ref('');
const password = ref('');
const loading = ref(false);
const error = ref('');

const { t } = useI18n();

const login = async () => {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
  loading.value = true;
  error.value = ''; // clear previous errors

  try {
    const response = await fetch('/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({ email: email.value, password: password.value }),
    });

    if (response.ok) {
      viewStore.setPrintTimeStart(null);
      viewStore.setPrintTimeEnd(null);
      viewStore.setUsername(email.value);
      window.location.href = '/';
    } else {
      // Try to parse error message if backend sends one
      const data = await response.json().catch(() => null);
      error.value = data?.error || 'Invalid email or password';
    }
  } catch (err) {
    console.error(err);
    error.value = 'loginerrornetwork';
  } finally {
    loading.value = false;
  }
};


</script>

<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-100">
    <Card class="w-full max-w-sm shadow-lg">
      <CardHeader>
		<img src="@/components/images/timin.png" alt="Timin Logo" class="h-8 w-8 object-contain" />
        <CardTitle class="text-center">Timin Login</CardTitle>
      </CardHeader>
      <CardContent>
        <form @submit.prevent="login" class="space-y-4">
          <Input
            type="text"
            placeholder="Email"
            v-model="email"
            required
          />

          <Input
            type="password"
            placeholder="Password"
            v-model="password"
            required
          />

          <div v-if="error" class="text-red-500 text-sm">{{ t('view.' + error) }}</div>

          <Button :disabled="loading" class="w-full">
            {{ loading ? 'Logging in...' : 'Login' }}
          </Button>
        </form>
      </CardContent>
    </Card>
  </div>
</template>